<template>
  <nav class="pagination" role="navigation" aria-label="pagination" v-if="shouldPaginate" :class="{'is-current-active': actionIcons }">
    <a
      class="pagination-previous is-mobile is-hidden-tablet is-hidden-desktop is-size-7-tablet is-size-7-desktop"
      :class="{'is-invisible':!prevUrl}"
      @click.prevent="page--"><span :class="[{'action-icons': actionIcons }]" v-html="previous"></span></a>
    <a @click.prevent="goToPage(pageNumb)" class="is-mobile is-hidden-tablet is-hidden-desktop" v-for="pageNumb in pageNumbersForMob"
       :class="[{ 'is-current': pageNumb === page}, {'is-current-active': actionIcons }, 'pagination-link', 'is-size-7-touch', 'is-size-7-desktop']"
       aria-label="`Goto page ${pageNumb}`">{{ pageNumb }}</a>
    <a class="pagination-next is-mobile is-hidden-tablet is-hidden-desktop is-size-7-tablet is-size-7-desktop"
       :class="{'is-invisible':!nextUrl}"
       @click.prevent="page++"><span :class="{'action-icons': actionIcons }" v-html="next"></span></a>
    <ul class="pagination-list is-hidden-mobile">
      <li v-show="prevUrl"><a @click.prevent="page--" :class="[{'is-current-active': actionIcons }]"
                              class="pagination-link is-size-7-touch is-size-7-desktop is-hidden-mobile"
                              aria-label="Previous"><span :class="{'action-icons': actionIcons }" v-html="previous"></span></a></li>
      <li v-show="showFirstPageLink"><a @click.prevent="goToPage(1)" :class="{'is-current-active': actionIcons }"
                                        class="pagination-link is-size-7-touch is-size-7-desktop"
                                        aria-label="Goto page 1">1</a></li>
      <li v-show="showFirstPageLink"><span
        class="pagination-ellipsis is-size-7-touch is-size-7-desktop">&hellip;</span></li>
      <li v-for="n in pageNumbers"><a @click.prevent="goToPage(n)"
                                      :class="[{ 'is-current': n === page}, {'is-current-active': actionIcons }, 'pagination-link', 'is-size-7-touch', 'is-size-7-desktop']"
                                      aria-label="`Goto page ${n}`">{{ n }}</a></li>
      <li v-show="showLastPageLink"><span
        class="pagination-ellipsis is-size-7-touch is-size-7-desktop">&hellip;</span></li>
      <li v-show="showLastPageLink"><a @click.prevent="goToPage(lastPage)" :class="{'is-current-active': actionIcons }"
                                       class="pagination-link is-size-7-touch is-size-7-desktop"
                                       :aria-label="`Goto page ${lastPage}`">{{ lastPage }}</a></li>
      <li v-show="nextUrl"><a @click.prevent="page++" :class="[{'is-current-active': actionIcons }]"
                              class="pagination-link is-size-7-touch is-size-7-desktop  is-hidden-mobile"
                              aria-label="Next"><span :class="{'action-icons': actionIcons }" v-html="next"></span></a></li>
    </ul>
  </nav>
</template>

<script>
/* eslint-disable indent,no-new,no-undef */

export default {
  name: 'paginator',
  props: [
    'dataSet',
    'keyword_string',
    'isNewPaginationActive',
    'canUpdateUrl'
  ],
  data () {
    return {
      page: 1,
      prevUrl: false,
      nextUrl: false,
      lastPage: 1,
      url: undefined,
      keyword: undefined,
      previous: `<img src="/static/img/ic-left-page.svg" style="vertical-align: middle;" />`,
      next: `<img src="/static/img/ic-right-page.svg" style="vertical-align: middle;" />`,
      actionIcons: false
    }
  },
  watch: {
    keyword_string () {
      this.keyword = this.keyword_string
    },
    dataSet: {
      handler () {
        this.page = this.dataSet.current_page
        this.prevUrl = this.dataSet.prev_page_url
        this.nextUrl = this.dataSet.next_page_url
        this.lastPage = this.dataSet.last_page
      },
      immediate: true
    },
    page () {
      this.broadCast()
      if (this.canUpdateUrl !== false) {
        this.updateUrl()
      }
    }
  },
  computed: {
    shouldPaginate () {
      return !!this.prevUrl || !!this.nextUrl
    },
    pageNumbers () {
      const pageGap = Math.floor(this.dataSet.per_page / 2)
      const curPage = this.page
      return Array.from({length: this.dataSet.last_page}, (x, i) => i + 1)
        .filter((x) => x === curPage || (x >= curPage - pageGap && x <= curPage + pageGap))
    },
    pageNumbersForMob () {
      let firstPage = this.page - 1
      if (!firstPage) {
        firstPage = this.page
      }

      const pageNumbers = []
      for (let i = firstPage; i < firstPage + 3; i++) {
        if (i > this.dataSet.last_page) {
          break
        }
        pageNumbers.push(i)
      }
      return pageNumbers
    },
    showFirstPageLink () {
      return this.page + 1 > this.dataSet.per_page - 1
    },
    showLastPageLink () {
      return this.page - 1 <= (this.lastPage - this.dataSet.per_page + 1)
    }
  },
  methods: {
    broadCast () {
      return this.$emit('changed', this.page, this.keyword)
    },
    updateUrl () {
      let queryObj = {}
      if (this.keyword_string) {
        this.url = `?page=${this.page}&keyword=${this.keyword_string}`
        queryObj = {
          page: this.page,
          keyword: this.keyword_string
        }
      } else {
        this.url = '?page=' + this.page
        queryObj = {
          page: this.page
        }
      }
      history.pushState(null, null, this.url)
      this.$router.push({query: queryObj})
    },
    goToPage (page) {
      this.page = page
    }
  },
  created () {
    if (this.isNewPaginationActive) {
      this.previous = '<img style="height: 10px;" src="/static/img/previous_icon.svg" />'
      this.next = '<img style="height: 10px;" src="/static/img/next_icon.svg" />'
      this.actionIcons = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/utilities/_colors.scss';

.pagination-previous, .pagination-next, .pagination-link, .pagination-ellipsis {
  border: none;
  color: #58595b;
  opacity: 0.6;
  font-size: 11px !important;
}

.pagination-link span.action-icons {
  display: flex;
}

.pagination-previous:hover:not(.is-current-active), .pagination-next:hover:not(.is-current-active), .pagination-link:hover:not(.is-current-active), .pagination-link.is-current:not(.is-current-active) {
  color: #58595b;
  border: 1px solid color('blue');
  background-color: transparent;
  height: 17px;
  justify-content: space-around;
}

.pagination-link.is-current {
  opacity: 1 !important;
  min-width: 17px;
}

.rev-list .pagination .pagination-list {
  justify-content: flex-end !important;
}

.action-icons {
  font-size: 19px;
}

.is-current.is-current-active {
  background: #fff;
  font-size: 11px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  width: 17px;
  height: 17px;
  border-radius: 2px;
  border: solid 1px color('blue');
  min-width: 0 !important;
}

div nav.is-current-active:not(.is-current) .pagination-list {
  font-size: 11px !important;
  font-weight: normal;
  color: #58595b;
  line-height: 1.36;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginator.vue